module.exports = __webpack_public_path__ + "fonts/8156f6219786a31577a27e017ea007bf.svg";